import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Navigation } from './Navigation';
import {
  gettingStarted,
  dashboard,
  notches,
  optionsSignals,
  stockSignals,
  howWePickTrades,
  algoTrading,
  netWorthTracker,
  fireCalculator,
  lifecyclePlanner,
  bucketVisualizer,
  playbook,
  subscriptionsBilling,
  tastyTradeConnection,
} from '../docs';
import './HelpDocs.css';

interface DocEntry {
  id: string;
  title: string;
  content: string;
}

const docs: DocEntry[] = [
  { id: 'getting-started', title: 'Getting Started', content: gettingStarted },
  { id: 'dashboard', title: 'Dashboard', content: dashboard },
  { id: 'notches', title: 'Notches', content: notches },
  { id: 'options-signals', title: 'Options Signals', content: optionsSignals },
  { id: 'stock-signals', title: 'Stock Signals', content: stockSignals },
  { id: 'how-we-pick-trades', title: 'How We Pick Trades', content: howWePickTrades },
  { id: 'algo-trading', title: 'Algo Trading Engine', content: algoTrading },
  { id: 'net-worth-tracker', title: 'Net Worth Tracker', content: netWorthTracker },
  { id: 'fire-calculator', title: 'FIRE Strategy Calculator', content: fireCalculator },
  { id: 'lifecycle-planner', title: 'Lifecycle Planner', content: lifecyclePlanner },
  { id: 'bucket-visualizer', title: 'Bucket Visualizer', content: bucketVisualizer },
  { id: 'playbook', title: 'Playbook', content: playbook },
  { id: 'subscriptions-billing', title: 'Subscriptions & Billing', content: subscriptionsBilling },
  { id: 'tastytrade-connection', title: 'TastyTrade Connection', content: tastyTradeConnection },
];

export const HelpDocs: React.FC = () => {
  const [activeDoc, setActiveDoc] = useState(docs[0].id);
  const [mobileTocOpen, setMobileTocOpen] = useState(false);

  const currentDoc = docs.find((d) => d.id === activeDoc) || docs[0];

  useEffect(() => {
    setMobileTocOpen(false);
    window.scrollTo(0, 0);
  }, [activeDoc]);

  return (
    <div className="help-docs-container">
      <Navigation />

      <div className="help-docs-page">
        <div className="help-docs-header">
          <h1>Help Documentation</h1>
          <p>Everything you need to know about the Wealth Financial Systems.</p>
          <button
            className="help-docs-toc-toggle"
            onClick={() => setMobileTocOpen(!mobileTocOpen)}
          >
            {mobileTocOpen ? 'Close Menu' : 'Browse Topics'}
          </button>
        </div>

        <div className="help-docs-layout">
          <aside className={`help-docs-sidebar ${mobileTocOpen ? 'open' : ''}`}>
            <nav className="help-docs-toc">
              {docs.map((doc) => (
                <button
                  key={doc.id}
                  className={`help-docs-toc-item ${activeDoc === doc.id ? 'active' : ''}`}
                  onClick={() => setActiveDoc(doc.id)}
                >
                  {doc.title}
                </button>
              ))}
            </nav>
          </aside>

          <article className="help-docs-content">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{currentDoc.content}</ReactMarkdown>
          </article>
        </div>
      </div>
    </div>
  );
};
